<template lang='pug'>
  .container.wrapper.component
    slot
</template>

<script>
  export default {
    name: 'digi-wrapper.component'
  }
</script>

<style scoped lang='stylus'>
  .wrapper
    margin 0 auto
    max-width 960px

  .wrapper.left
    margin-left 0

  .wrapper.text
    max-width 36em

  .wrapper.max-480
    max-width 480px
  .wrapper.max-640
    max-width 640px
  .wrapper.max-800
    max-width 800px
  .wrapper.max-960
    max-width 960px
  .wrapper.max-1080
    max-width 1080px
  .wrapper.max-1280
    max-width 1280px
</style>
